import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
//import BusinessNoWaiver from "./BusinessNoWaiver/BusinessNoWaiver";
//import API_URL from "../../api/API";
import Sidebar from "../../components/Sidebar";
import WaiversList from "../waiversmanage/WaiversList";

const BusinessExistingWaivers = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();


  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }
  }, [business, navigate]);
 

  return (
    <div className="h-screen flex flex-row bg-background">

      <Sidebar />

      <div className="flex-1 h-auto overflow-visible py-9 transition">
     
        <div className="flex-1 overflow-visible py-9">
          <WaiversList />
        </div>        
      </div>
    </div>
  );
};

export default BusinessExistingWaivers;